import { Button } from "@/components/flexkit/Button";
import { Text } from "@/components/podkit/typography/Text";
import { DeleteAccountModal } from "@/components/settings/profile/DeleteAccountModal";
import { useGetAccount } from "@/queries/account-queries";
import { useState, type FC } from "react";

export const DeleteAccount: FC = () => {
    // Explicitly not handling loading/error states for account/user as that's taken care of in AuthenticatedUserLayout
    const { data: account } = useGetAccount();
    const [open, setOpen] = useState(false);

    if (!account) {
        return;
    }

    return (
        <>
            <div className="flex flex-col gap-4">
                <div className="flex flex-col gap-1">
                    <span className="text-md font-medium text-content-primary">Delete Personal Account</span>
                    <Text className="text-base text-content-secondary">
                        This will permanently delete your personal Ona account and all associated data. You won&apos;t
                        be able to recover this account once it&apos;s deleted.
                    </Text>
                    <Text className="mt-2 text-base text-content-secondary">
                        This won&apos;t affect any organizations you&apos;re a member of.
                    </Text>
                </div>
                <Button
                    variant="destructive"
                    className="w-fit"
                    onClick={() => setOpen(true)}
                    data-testid="delete-account-btn"
                    data-tracking-id="delete-account"
                >
                    Delete Account
                </Button>
            </div>
            <DeleteAccountModal account={account} open={open} onClose={() => setOpen(false)} />
        </>
    );
};
